// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"_ab980d6","bonusInput":"_fbcc37b","panel":"_4df8614","panelContent":"_b5150a0","fundsIcon":"_8137f13","fundsAmountContainer":"_e7df44a","fundsAmountBalance":"_23b6297"};